import * as _ from 'lodash';
import * as moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { Dispatch, connect } from 'react-redux';
import { AppActionCreators, IApplicationState, ReportActionCreators, ActionCenterActionCreators, IRelativePerformanceResponse, IWaitlistAuditResponse } from '@nkr/store/index';
// import { IWaitlistAuditResponse } from '@nkr/store/reports';
import { IRpChainEndDeclineRatio, IWaitlistAudit } from '@nkr/models/index';
import { AgGridReact } from 'ag-grid-react';
import { IHeaderParams, GridReadyEvent, ValueGetterParams, FirstDataRenderedEvent, ColDef, SortChangedEvent, GridSizeChangedEvent } from 'ag-grid-community';
import { ReportWrapper } from './styles';
import { Button, FormControl, Label } from 'react-bootstrap';
import { Utility } from '@nkr/services/utility';
// import { IRpChainEndDeclineRatio } from '@nkr/models/center-performance/relative-performance';
import { ChainEndDeclineRatioOverlay } from '@nkr/views/center-admin/action-center/center-performance/relative-performance-overlays';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import AuditReportScoreTable from '../audit-report-score-table';

const getFooterRow = (rows: IWaitlistAudit[]): IWaitlistAudit | null => {
    if (!rows.length) {
        return null;
    }

    let isIncluded = _.sumBy(rows, row => row.isExcludedFromDeclineRatio == 1 ? 0 : 1);
    let isAccepted = _.sumBy(rows, row => row.isExcludedFromDeclineRatio || row.isAccepted ? 0 : 1);
    let declineRatio = isIncluded > 0 ? _.round((isAccepted / isIncluded) * 100, 0) : 0;

    return {
        recipientCenterId: 0,
        recipientCenterAlias: '',
        donorCenterId: 0,
        donorCenterAlias: '',
        donorAlias: '',
        donorAbo: '',
        swapNumber: '',
        recipientAlias: '',
        offerDate: '',
        decisionDate: '',
        decision: '',
        rejectionReasonText: '',
        rejectionReasonId: 0,
        rejectionReason: '',
        rootCauseId: 0,
        rootCause: '',
        isAccepted,
        isExcludedFromDeclineRatio: isIncluded,
        declineRatio: declineRatio
    };
};

interface IProps {
    centerId: number
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getWaitlistAudit: (centerId: number, startDate: string, endDate: string) => Promise<IWaitlistAuditResponse>,
    getRelativePerformance: (centerId: number, startDate: string, endDate: string) => Promise<IRelativePerformanceResponse>
}

type TProps = IStateProps & IDispatchProps & IProps

const WaitlistAuditReport = (props: TProps) => {
    const [data, setData] = useState<IWaitlistAudit[]>([]);
    const [chainEndDeclineRatio, setChainEndDeclineRatio] = useState<IRpChainEndDeclineRatio>(null);
    const [mounted, setMounted] = useState(true);
    const [startDate, setStartDate] = useState(moment().add(-6, 'month').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));

    useEffect(() => {
        getData(startDate, endDate);
        return () => setMounted(false);
    }, [props.centerId]);

    const onGridReady = (e: GridReadyEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onSortChanged = (e: SortChangedEvent) => {
        e.api.refreshCells();
    };

    const onGridSizeChanged = (e: GridSizeChangedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const getData = (sd: string, ed: string) => {
        let { centerId } = props;

        if (mounted) {
            props.showLoading('Getting Waitlist Audit, one moment please...').then(() => {
                props.getWaitlistAudit(centerId, sd, ed).then(response => {
                    setData(response.data.results);
                    props.hideLoading();
                });
            });

            props.getRelativePerformance(centerId, '', '').then(response => {
                setChainEndDeclineRatio(response.data.results.relativePerformance.chainEndDeclineRatio);
            });
        }
    };

    const handleSearch = () => {
        getData(startDate, endDate);
    };

    const cols: ColDef[] = [
        {
            colId: 'rank',
            headerName: 'Rank',
            headerClass: 'list-header',
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>R#</SortableHeaderComponent>,
            minWidth: 60,
            maxWidth: 60,
            cellClass: 'list-cell',
            sortable: true,
            resizable: false,
            valueGetter: (props: ValueGetterParams) => props.node.rowPinned ? null : props.node.rowIndex + 1
        },
        {
            colId: 'swapNumber',
            field: 'swapNumber',
            headerName: 'Swap Number',
            headerClass: 'list-header',
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Swap<br />Number</SortableHeaderComponent>,
            width: 90,
            minWidth: 80,
            cellClass: 'list-cell',
            sortable: true,
            resizable: false
        },
        {
            colId: 'donorCenterAlias',
            field: 'donorCenterAlias',
            headerName: 'Donor Center',
            headerClass: 'list-header',
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Donor<br />Center</SortableHeaderComponent>,
            width: 120,
            minWidth: 100,
            cellClass: 'list-cell',
            sortable: true,
            resizable: false
        },
        {
            colId: 'donorAlias',
            field: 'donorAlias',
            headerName: 'Donor Alias',
            headerClass: 'list-header',
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Donor<br />Alias</SortableHeaderComponent>,
            width: 120,
            minWidth: 100,
            cellClass: 'list-cell',
            sortable: true,
            resizable: false,
        },
        {
            colId: 'donorAbo',
            field: 'donorAbo',
            headerName: 'Donor Abo',
            headerClass: 'list-header',
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Donor<br />ABO</SortableHeaderComponent>,
            width: 55,
            cellClass: 'list-cell',
            sortable: true,
            resizable: false
        },
        {
            colId: 'recipientAlias',
            field: 'recipientAlias',
            headerName: 'WLP Alias',
            headerClass: 'list-header',
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>WLP<br />Alias</SortableHeaderComponent>,
            width: 120,
            minWidth: 100,
            cellClass: 'list-cell',
            sortable: true,
            resizable: false
        },
        {
            colId: 'offerDate',
            field: 'offerDate',
            headerName: 'Offer Date',
            headerClass: 'list-header',
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Offer<br />Date</SortableHeaderComponent>,
            minWidth: 55,
            maxWidth: 100,
            cellClass: 'list-cell',
            sortable: true,
            resizable: false,
            comparator: Utility.dateComparator
        },
        {
            colId: 'decisionDate',
            field: 'decisionDate',
            headerName: 'Decision Date',
            headerClass: 'list-header',
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Decision<br />Date</SortableHeaderComponent>,
            minWidth: 65,
            maxWidth: 100,
            cellClass: 'list-cell',
            sortable: true,
            resizable: false,
            comparator: Utility.dateComparator
        },
        {
            colId: 'decision',
            field: 'decision',
            headerName: 'Decision',
            headerClass: 'list-header',
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Decision</SortableHeaderComponent>,
            minWidth: 55,
            maxWidth: 100,
            cellClass: 'list-cell',
            sortable: true,
            resizable: false
        },
        {
            colId: 'rejectionReason',
            field: 'rejectionReason',
            headerName: 'Rejection Reason',
            headerClass: 'list-header',
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Rejection<br />Reason</SortableHeaderComponent>,
            width: 145,
            cellClass: 'list-cell',
            sortable: true,
            resizable: false
        },
        {
            colId: 'rootCause',
            field: 'rootCause',
            headerName: 'Root Cause',
            headerClass: 'list-header',
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Root<br />Cause</SortableHeaderComponent>,
            width: 145,
            cellClass: 'list-cell',
            sortable: true,
            resizable: false
        },
        {
            colId: 'isAccepted',
            field: 'isAccepted',
            headerName: 'Ratio Impacting Decline',
            headerClass: 'list-header',
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Ratio<br />Impacting<br />Decline</SortableHeaderComponent>,
            width: 75,
            cellClass: 'list-cell',
            sortable: true,
            resizable: false,
            valueGetter: (props: ValueGetterParams) => props.node.rowPinned
                ? props.data?.isAccepted
                : (props.data?.isExcludedFromDeclineRatio ? '--' : (props.data?.isAccepted == true ? 0 : 1)),
            cellRendererFramework: (props: any) => { return props.value == '--' ? '--' : (props.value > 0 ? <Label bsStyle="danger">{props.value}</Label> : <Label bsStyle="success">{props.value}</Label>); }
        },
        {
            colId: 'isIncluded',
            field: 'isIncluded',
            headerName: 'Ratio Impacting Offer',
            headerClass: 'list-header',
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Ratio<br />Impacting<br />Offer</SortableHeaderComponent>,
            width: 75,
            cellClass: 'list-cell',
            sortable: true,
            resizable: false,
            valueGetter: (props: ValueGetterParams) => props.node.rowPinned
                ? props.data?.isExcludedFromDeclineRatio
                : (props.data?.isExcludedFromDeclineRatio ? '--' : 1)
        },
        {
            colId: 'declineRatio',
            field: 'declineRatio',
            headerName: 'Decline Ratio Result',
            headerClass: 'list-header',
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Decline<br />Ratio<br />Result</SortableHeaderComponent>,
            width: 75,
            cellClass: 'list-cell',
            sortable: false,
            resizable: false,
            valueGetter: (props: ValueGetterParams) => props.node.rowPinned ? props.data?.declineRatio : null,
            cellRendererFramework: (props: any) => { return props.node.rowPinned ? (props.value > 0 ? <Label bsStyle="danger">{props.value}%</Label> : <Label bsStyle="success">{props.value}%</Label>) : '--'; }
        }
    ];

    const columnDefs = useMemo(() => cols, []);
    const rowData = useMemo(() => data, [data]);

    const pinnedRowData = useMemo(() => {
        let footerRow = getFooterRow(rowData);
        return footerRow ? [footerRow] : [];
    }, [rowData]);

    const chainEndDeclineRatioData: IRpChainEndDeclineRatio = chainEndDeclineRatio || {
        rank: 0,
        declines: 0,
        starts: 0,
        wlpOffers: 0,
        wlpDeclines: 0,
        declineRatio: 0,
        category: 'Waitlist Offer Decline Ratio (Last 6 Months)'
    }

    return (
        <>
            <div className='well well-sm' style={{ marginBottom: 5 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '75%' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                            <div style={{ marginRight: 5 }}>Start&nbsp;Date:</div>
                            <FormControl
                                type='date'
                                value={startDate}
                                onChange={(e: any) => setStartDate(e.target.value)}
                            />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                            <div style={{ marginRight: 5 }}>End&nbsp;Date:</div>
                            <FormControl
                                type='date'
                                value={endDate}
                                onChange={(e: any) => setEndDate(e.target.value)}
                            />
                        </div>
                        <Button bsStyle='primary' onClick={handleSearch}>Search</Button>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <AuditReportScoreTable
                            reportName='Waitlist Offer Decline Ratio (Last 6 Months)'
                            scoreValue={chainEndDeclineRatio ? chainEndDeclineRatio.declineRatio + '%' : '0'}
                            overlay={ChainEndDeclineRatioOverlay({ chainEndDeclineRatio: chainEndDeclineRatioData })}
                        />
                    </div>
                </div>
            </div>

            <div>
                <ReportWrapper className='ag-theme-bootstrap'>
                    <AgGridReact
                        columnDefs={columnDefs}
                        rowData={rowData}
                        headerHeight={65}
                        groupHeaderHeight={30}
                        rowHeight={30}
                        suppressRowClickSelection={false}
                        suppressCellSelection={true}
                        noRowsOverlayComponentFramework={() => <div>No Waitlist Offers for the last 6 months...</div>}
                        onGridReady={onGridReady}
                        onFirstDataRendered={onFirstDataRendered}
                        onSortChanged={onSortChanged}
                        onGridSizeChanged={onGridSizeChanged}
                        pinnedTopRowData={pinnedRowData}
                        getRowStyle={(params: any) => params.node.rowPinned ? { backgroundColor: 'lightblue' } : null}
                    >

                    </AgGridReact>
                </ReportWrapper>
            </div>
        </>
    );
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {};
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getWaitlistAudit: (centerId, startDate, endDate) => { return dispatch(ReportActionCreators.getWaitlistAudit(centerId, startDate, endDate)); },
        getRelativePerformance: (centerId, startDate, endDate) => { return dispatch(ActionCenterActionCreators.getRelativePerformance(centerId, startDate, endDate)); }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(WaitlistAuditReport);